/* eslint-disable camelcase */
// import $ from "jquery";

export default {
	init() {},
	finalize() {
		// JavaScript to be fired on the about page, after the init JS
	}
};
